import React from 'react';import Review from '../components/Review.jsx';export default function Film(){return <Review kind="film"/>;}
